// The user API serializes Sequelize's authoritative created_at DATE as ISO UTC.
// Never manufacture a time for legacy date-only or timezone-ambiguous values.
export function registrationDateTime(value) {
  const unavailable = { date: 'Date unavailable', time: 'Time unavailable' };
  if (!value) return unavailable;
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const date = new Date(`${value}T00:00:00Z`);
    if (!Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === value) {
      const [year, month, day] = value.split('-');
      return { date: `${day}/${month}/${year}`, time: unavailable.time };
    }
    return unavailable;
  }
  if (!(value instanceof Date) && (typeof value !== 'string' || !/T.*(?:Z|[+-]\d{2}:?\d{2})$/i.test(value))) return unavailable;
  const instant = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(instant.getTime())) return unavailable;
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Africa/Lagos', day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', hour12: true
  }).formatToParts(instant).map(part => [part.type, part.value]));
  return { date: `${parts.day}/${parts.month}/${parts.year}`, time: `${parts.hour}:${parts.minute} ${parts.dayPeriod.toUpperCase()}` };
}
